import type { ActivityLocation } from '$/dto/ItineraryData.dto.ts';
import BookedStayFallbackName from '$/_const/trip/BookedStayFallbackName.ts';
import { getLocationQuery, hasCoordinates } from '@/utils/googleMaps.ts';

const fallbackStayNames: ReadonlySet<string> = new Set(Object.values(BookedStayFallbackName));

const buildPlaceMapsUrl = (location: ActivityLocation | null | undefined): string | null => {
  const name = location?.name?.trim();

  if (!location || !name) return null;

  const placeId = location.google_place_id?.trim();
  const isUnlocatableStay =
    !placeId && !hasCoordinates(location) && !location.formatted_address?.trim() && fallbackStayNames.has(name);

  if (isUnlocatableStay) return null;

  const url = new URL('https://www.google.com/maps/search/');
  url.searchParams.set('api', '1');

  if (placeId) {
    url.searchParams.set('query', [name, location.city].filter(Boolean).join(', '));
    url.searchParams.set('query_place_id', placeId);
  } else {
    url.searchParams.set('query', getLocationQuery(location));
  }

  return url.toString();
};

export default buildPlaceMapsUrl;
